import React, { memo } from "react";
import Map, { Marker } from "react-map-gl/mapbox";
import "mapbox-gl/dist/mapbox-gl.css";

import styles from "./styles.module.scss";

const MAPBOX_TOKEN =
	"pk.eyJ1IjoiZGFmaWRhZmkyNSIsImEiOiJjbTdsczg0Y3QwYnEwMmpwemIxZ2h4dHY0In0.dcTST_LLYTlp-t_oUkB0dw";

interface IMap {
	lat: number;
	lng: number;
}

const EventMap: React.FunctionComponent<IMap> = ({ lat, lng }) => {
	return (
		<div className={styles.container}>
			<Map
				mapboxAccessToken={MAPBOX_TOKEN}
				initialViewState={{
					latitude: lat,
					longitude: lng,
					zoom: 13,
				}}
				mapStyle="mapbox://styles/mapbox/streets-v12"
				style={{ width: "100%", height: "100%" }}
				attributionControl={false}
			>
				<Marker latitude={lat} longitude={lng} color="#e74c3c" />
			</Map>
		</div>
	);
};

export default memo(EventMap);
